// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tVVw","colMin":"styles_colMin__WGB4b"};